/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { POST, GET } from '/client/src/api';
import { emailRegexp } from '/client/src/constants';
const queryString = require('query-string');

type PropsType = {
};

const SignUp = ({ }: PropsType): React.Element<typeof React.Fragment> => {
  const [email, setEmail] = React.useState('');
  const emailValidationMessage = React.createRef();
  const emailResendValidationMessage = React.createRef();
  const [isIsset, setIsset] = React.useState(false);
  const [step, setStep] = React.useState('registration');  // registration / send / resend

  const refferalMerchantId = _.get(queryString.parse(window.location.search), 'referral_merchant_id', null);
  const referralsId = _.get(queryString.parse(window.location.search), 'referrals_id', null);

  React.useEffect(() => {
    const isValid = emailRegexp.test(email);

    const tryEmail = async () => {
      try {
        const { result } = await GET(`/api/v1/1/account/check_email?email_address=${encodeURIComponent(email)}`);

        if (!result.is_available) {
          renderEmailValidationMsg('An account with this email already exists.', emailValidationMessage || emailResendValidationMessage);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (isValid) {
      tryEmail();
    }
  }, [email]);

  React.useEffect(() => {
    setIsset(false);
  }, [step]);

  const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    const isValid = emailRegexp.test(email);

    if (isValid) {
      try {
        setStatus('loading');

        await POST('/api/v1/1/merchants/signup', {
          email,
          is_app: true,
          referral_merchant_id: refferalMerchantId,
          referrals_id: referralsId
        });

        setStatus('success');
        setStep('send');
      } catch (error) {
        setStatus('error');
        const allReadyExist = _.get(error, 'data.error.message', null);

        if (allReadyExist) {
          setIsset(allReadyExist);
        }

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    } else {
      renderEmailValidationMsg('Please enter a proper email address.', emailValidationMessage);
    }
  };

  const resendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
    setIsset(false);

    e.preventDefault();

    const isValid = emailRegexp.test(email);

    if (isValid) {
      try {
        setStatus('loading');

        await POST('/api/v1/1/account/send_confirm_email', {
          email_address:email,
          is_app: true
        });

        setStatus('success');
        setStep('send');
      } catch (error) {
        setStatus('error');
        const allReadyExist = _.get(error, 'data.error.message', null);

        if (allReadyExist) {
          setIsset(allReadyExist);
        }

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    } else {
      renderEmailValidationMsg('Please enter a proper email address.', emailResendValidationMessage);
    }
  };

  const renderEmailValidationMsg = (msg: string, El: any) => {
    const validationMessageEl = El.current.querySelector('.validationMessage');

    emailValidationMessage.current.classList.add('has-error');
    emailValidationMessage.current.querySelector('input').classList.add('validationElement');
    validationMessageEl.innerText = msg;
  };

  return (
    <>
      <div className="form-box-container">
        <div className="form-box-message">
          <h3 className="auth-message-header">
            {step === 'registration' && 'Get started for FREE'}

            {step === 'send' && 'Check your email'}

            {step === 'resend' && 'Resend email confirmation'}
          </h3>
          <div
            className="auth-message-desc"
          >
            {step === 'registration' &&
              <>
                Always FREE for event organizers! Review our&nbsp;
                <a href="https://www.sparxo.com/knowledge-base/understanding-your-payouts/" target="_blank" rel="noreferrer noopener">payout</a>&nbsp;
                and &nbsp;<a href="https://www.sparxo.com/pricing/" target="_blank" rel="noreferrer noopener">pricing</a> pages.
              </>
            }

            {step === 'send' && 'An email confirmation was sent to:'}

            {step === 'resend' && 'Enter your email below.'}
          </div>

          {isIsset &&
            <div className="alert alert-danger mt-3">
              <div data-bind="text: errorMessage">{isIsset}</div>
            </div>
          }
        </div>

        {step === 'registration' &&
          <form className="mt-5" role="form">
            <div className="mt-4">
              <label htmlFor="email">Work email address</label>
              <div ref={emailValidationMessage}>
                <input
                  className="form-control"
                  type="email"
                  title="This field is required."
                  value={email}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    emailValidationMessage.current.classList.remove('has-error');
                    emailValidationMessage.current.querySelector('input').classList.remove('validationElement');
                    setEmail(e.target.value);
                  }}
                />
                <span
                  className="validationMessage"
                >This field is required.</span>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-xs-12 text-center">
                <BtnLoader
                  label='Get Started!'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    sendRequest(e, setStatus);
                  }}
                />
              </div>
            </div>
          </form>
        }

        {step === 'send' &&
          <>
            <div className="email" style={{ margin: '.75rem 0' }}><b>{email}</b></div>
            <div style={{ lineHeight: 1.5 }}>
              Follow the instructions in that email to confirm your email address. &nbsp;
              Check all folders in your inbox including your spam folder.
            </div>
            <div style={{ marginTop: '2rem' }}>
              <span className="text">Can't find the email?</span>
              <div
                className="btn btn-sm btn-color-logo-outline btn-round"
                role="button"
                style={{ marginLeft: '1rem', borderRadius: '50px' }}
                onClick={() => setStep('resend')}
              >
                Resend email confirmation
              </div>
            </div>
          </>
        }

        {step === 'resend' &&
          <form className="mt-5" role="form">
            <div className="mt-4">
              <label htmlFor="email">Email</label>
              <div ref={emailResendValidationMessage}>
                <input
                  className="form-control"
                  type="email"
                  title="This field is required."
                  value={email}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    emailResendValidationMessage.current.classList.remove('has-error');
                    emailResendValidationMessage.current.querySelector('input').classList.remove('validationElement');
                    setEmail(e.target.value);
                  }}
                />
                <span className="validationMessage">Please enter a proper email address.</span>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-xs-12 text-center">
                <BtnLoader
                  label='Resend Email'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    resendRequest(e, setStatus);
                  }}
                />
              </div>
            </div>
          </form>
        }
      </div>
    </>
  );
};

export default SignUp;
